export default __webpack_public_path__ + "static/media/blur 2.6e7b8bb9.jpg";